import { TimelineInterval, ParsedTimeBoundaries } from '@/types/streaming';
import { MILLISECONDS_TO_SECONDS } from '@/constants/time';

export function parseViinexTimeBoundaries(
    boundaries: [string, string] | null,
): ParsedTimeBoundaries | null {
    if (!boundaries || boundaries.length !== 2) {
        return null;
    }

    const earliestMilliseconds =
        typeof boundaries[0] === 'string'
            ? Date.parse(boundaries[0])
            : Number(boundaries[0]);
    const latestMilliseconds =
        typeof boundaries[1] === 'string'
            ? Date.parse(boundaries[1])
            : Number(boundaries[1]);

    if (isNaN(earliestMilliseconds) || isNaN(latestMilliseconds)) {
        return null;
    }

    return {
        earliestMilliseconds,
        latestMilliseconds,
        earliestSeconds: earliestMilliseconds / MILLISECONDS_TO_SECONDS,
        latestSeconds: latestMilliseconds / MILLISECONDS_TO_SECONDS,
    };
}

export function parseViinexTimelineIntervals(
    timelineData: [string, string][] | null | undefined,
    earliestSeconds: number,
    latestSeconds: number,
): TimelineInterval[] {
    if (!timelineData || timelineData.length === 0) {
        return [{ begin: earliestSeconds, end: latestSeconds }];
    }

    const intervals = timelineData.map(([beginStr, endStr]) => ({
        begin: new Date(beginStr).getTime() / MILLISECONDS_TO_SECONDS,
        end: new Date(endStr).getTime() / MILLISECONDS_TO_SECONDS,
    }));

    if (intervals.every((interval) => interval.begin === interval.end)) {
        return [{ begin: earliestSeconds, end: latestSeconds }];
    }

    return intervals;
}
